import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
let StatisticsStore = class StatisticsStore extends VuexModule {
    dates = [];
    setStatisticDates(statisticDates) {
        this.dates = statisticDates;
    }
};
__decorate([
    Mutation
], StatisticsStore.prototype, "setStatisticDates", null);
StatisticsStore = __decorate([
    Module({
        namespaced: true,
    })
], StatisticsStore);
export default StatisticsStore;
